const browserStorage =
  storage =>
  (prefix = '', logger = console) => {
    const getItemId = key => `${prefix || ''}-${key}`;

    return {
      set(key, data) {
        try {
          storage.setItem(getItemId(key), JSON.stringify(data));
        } catch (e) {
          logger.error(e);
        }
      },
      get(key) {
        return JSON.parse(storage.getItem(getItemId(key) || 'null'));
      },
      remove(key) {
        storage.removeItem(getItemId(key));
      },
    };
  };

export const localStorage = browserStorage(window.localStorage);
export const sessionStorage = browserStorage(window.sessionStorage);
